import React from 'react';
import { Page, DataGrid, DataGridColumn, BText } from '../../../components';

export const DemoDataGrid = () => {
  const data = [
    { name: 'John', age: 35, status: true },
    { name: 'Adam', age: 36, status: false },
    { name: 'Ali', age: 37, status: false },
    { name: 'Jenet', age: 38, status: true },
  ];

  const column: DataGridColumn[] = [
    { label: 'Name', key: 'name', width: 100, sortable: true },
    { label: 'Age', key: 'age', width: 100, sortable: true, dataType: 'number' },
    {
      label: 'Status',
      key: 'status',
      width: 100,
      sortable: true,
      dataType: 'boolean',
      cellRender: (item: any) => <BText>{`${item.name} - ${item.status ? 'Active' : 'Inactive'}`}</BText>,
    },
  ];

  return (
    <Page title={'Demo - Datagrid'}>
      <DataGrid
        data={data}
        columns={column}
        actions={[
          {
            label: 'Edit',
            action: (item: any) => console.log('Edit', item),
          },
          {
            label: 'Delete',
            action: (item: any) => console.log('Delete', item),
            disable: (item: any) => !item.status,
          },
        ]}
        defaultSort={{ key: 'name', direction: 'ascending' }}
        onDoubleClick={(item: any) => console.log('DblClick', item)}
        onSelect={(item: any) => console.log('select', item)}
        primaryButton={{
          label: 'Add',
          action: () => console.log('Add click'),
        }}
      />
    </Page>
  );
};
